import { useState } from "react";
import { notification } from "antd";

export const useHooks = ({
  getZones,
  postZones,
  patchZones,
  delZones,
  putWarehouseZones,
  postWarehouseZones,
  delWarehouseZones,
  getWarehouseZones,
  zoneWarehouseZones,
  updateZoneStateZones,
  updateZoneNameZones,
  updateZoneInfoZones,
}) => {
  const [zones, setZones] = useState([]);
  const [warehouses, setWarehouses] = useState([]);

  const loadZones = () => {
    getZones().then((zones) => {
      const newZones = zones.body;
      
      // ✅ Convert backend 'long' to frontend 'lng' for map display
      newZones.forEach((zone) => {
        zone.polygon = zone.form.polygon;
        zone.polygon.forEach((polygon) => {
          polygon.lng = polygon.long;  // Leaflet maps use 'lng'
        });
      });
      
      setZones(newZones);
    });
  };

  // ✅ NO CHANGES NEEDED - Modal already sends correct format
  const handleAddZones = (newZone) => {
    console.log('📤 Sending zone to backend:', newZone);
    
    postZones(newZone).then(
      () => {
        notification.success({
          message: "Success",
          description: "Zone created successfully!",
        });
        loadZones();
      },
      (err) => {
        console.error('❌ Error creating zone:', err);
        notification.error({
          message: "Error",
          description: err?.message || "Can't create zone here!",
        });
      },
    );
  };

  const handleDeleteZones = (zone) => (event) => {
    delZones(zone).then(
      () => {
        notification.success({
          message: "Success",
          description: "Zone deleted successfully!",
        });
        loadZones();
      },
      (err) => {
        console.error('❌ Error deleting zone:', err);
        notification.error({
          message: "Error",
          description: "Can't delete zone!",
        });
      },
    );
  };

  const handleUpdateZones = (newZone) => {
    patchZones(newZone).then(
      () => {
        notification.success({
          message: "Success",
          description: "Zone updated successfully!",
        });
        loadZones();
      },
      (err) => {
        console.error('❌ Error updating zone:', err);
        notification.error({
          message: "Error",
          description: "Can't update zone!",
        });
      },
    );
  };

  const handleZoneWarehouseChange = (zoneId) => (warehouseId) => {
    zoneWarehouseZones({ warehouseId, id: zoneId })
      .then(() => {
        notification.success({
          message: "Success",
          description: "Warehouse assigned successfully!",
        });
        loadZones();
      })
      .catch((err) => {
        console.error('❌ Error assigning warehouse:', err);
        notification.error({
          message: "Error",
          description: "Can't assign warehouse!",
        });
      });
  };

  const loadWarehouses = () => {
    getWarehouseZones().then((zones) => {
      const formattedWarehouses = zones.body.map((warehouse) => ({
        ...warehouse,
        lat: parseFloat(warehouse.lat),
        long: parseFloat(warehouse.long),
      }));
      setWarehouses(formattedWarehouses);
    });
  };

  const handleAddWarehouse = (newWarehouse) => {
    postWarehouseZones(newWarehouse).then(
      () => {
        notification.success({
          message: "Success",
          description: "Warehouse created successfully!",
        });
        loadWarehouses();
      },
      (err) => {
        console.error('❌ Error creating warehouse:', err);
        notification.error({
          message: "Error",
          description: "Make sure you provided valid name and address!",
        });
      },
    );
  };

  const handleDeleteWarehouse = (warehouse) => {
    delWarehouseZones(warehouse).then(
      () => {
        notification.success({
          message: "Success",
          description: "Warehouse deleted successfully!",
        });
        loadWarehouses();
      },
      (err) => {
        console.error('❌ Error deleting warehouse:', err);
        notification.error({
          message: "Error",
          description: "Can't delete warehouse!",
        });
      },
    );
  };

  const handleUpdateWarehouse = (warehouse) => {
    putWarehouseZones(warehouse).then(
      () => {
        notification.success({
          message: "Success",
          description: "Warehouse updated successfully!",
        });
        loadWarehouses();
      },
      (err) => {
        console.error('❌ Error updating warehouse:', err);
        notification.error({
          message: "Error",
          description: "Can't update warehouse!",
        });
      },
    );
  };

  const handleUpdateZoneName = (zone) => {
    updateZoneNameZones(zone).then(
      ({ body: updatedZoneResp }) => {
        notification.success({
          message: "Success",
          description: "Zone name updated successfully",
        });
        handleUpdateZoneState(updatedZoneResp);
        loadZones();
      },
      (err) => {
        console.error('❌ Error updating zone name:', err);
        notification.error({
          message: "Error",
          description: "Can't update zone name!",
        });
      },
    );
  };

  const handleUpdateZoneInfo = (zoneData) => {
    return updateZoneInfoZones(zoneData).then(
      ({ body: updatedZone }) => {
        notification.success({
          message: "Success",
          description: "Zone information updated successfully",
        });
        handleUpdateZoneState(updatedZone);
        loadZones();
        return updatedZone;
      },
      (err) => {
        console.error('❌ Error updating zone info:', err);
        notification.error({
          message: "Error",
          description: err?.message || "Can't update zone information!",
        });
        throw err;
      },
    );
  };

  const handleUpdateZoneState = (updatedZone) => {
    updateZoneStateZones(updatedZone).then(
      () => {},
      (err) => {
        console.error('❌ Error updating zone state:', err);
        notification.error({
          message: "Error",
          description: "Can't update zone state!",
        });
      },
    );
  };

  return {
    zones,
    warehouses,
    loadZones,
    loadWarehouses,
    handleAddZones,
    handleUpdateZones,
    handleDeleteZones,
    handleAddWarehouse,
    handleDeleteWarehouse,
    handleUpdateWarehouse,
    handleZoneWarehouseChange,
    handleUpdateZoneState,
    handleUpdateZoneName,
    handleUpdateZoneInfo,
  };
};